import React from "react";
import { Image, Button } from "react-bootstrap";
import './EmptyState.css';

interface EmptyStateProps {
    image?: string | React.ElementType;   // image path OR icon component
    icon?: React.ReactNode;
    title?: string;
    description?: string;
    size?: number;
    className?: string;
    buttonText?: string;
    onButtonClick?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({
    image,
    icon,
    title = "No Data Available",
    description = "Nothing to display right now.",
    size = 80,
    className = "",
    buttonText,
    onButtonClick,
}) => {

    const isStringImage = typeof image === "string";

    return (
        <div
            className={`d-flex flex-column align-items-center justify-content-center text-center empty_content ${className}`}
            style={{ padding: "30px 20px" }}
        >

            {/* CASE 1 — STRING IMAGE PATH */}
            {icon}
            {!icon && image && isStringImage && (
                <Image
                    src={image as string}
                    alt="empty-state"
                    style={{
                        width: size,
                        height: size,
                        objectFit: "contain",
                        opacity: 0.9,
                    }}
                    
                />
            )}

            {/* CASE 2 — ICON COMPONENT */}
            {!icon && image && !isStringImage && (
                (() => {
                    const IconComponent = image as React.ElementType;
                    return (
                        <IconComponent
                            size={size}              // <-- react-icons uses size
                            style={{ opacity: 0.9 }}
                            className=".cpv-heading-row h1"
                        />
                    );
                })()
            )}

            {/* TITLE */}
            <h5 className="fw-semibold">{title}</h5>

            {/* DESCRIPTION */}
            <p className="text-muted" style={{ maxWidth: 400 }}>
                {description}
            </p>

            {/* OPTIONAL BUTTON */}
            {buttonText && (
                <Button variant="primary" onClick={onButtonClick} className="mt-2">
                    {buttonText}
                </Button>
            )}
        </div>
    );
};

export default EmptyState;
